<template>
  <header v-if='categorypages'>
    <h2 v-html='"All"' @click='updateSelection("All")' :class='{chosen: modelValue == "All"}' />
    <nav>
      <template v-for="title in categorypages.map(item => item?.title)" >
        <h2 v-if='title' v-html='title' @click='updateSelection(title)' :class='{chosen: modelValue == title}':key="title" />
      </template>
    </nav>
  </header>
</template>

<script setup>
const props = defineProps(['categorypages', 'modelValue']);
const emit = defineEmits(['update:modelValue']);

const updateSelection = (value) => {
  emit('update:modelValue', value);
};
</script>

<style scoped>
header {
  text-align: center;
  max-width: 60rem;
  margin: auto;
}

header nav {
  margin: auto;
}

header h2 {
  display: inline-block;
  margin: 0;
  vertical-align: top;
  line-height: 0.8em;
  padding-bottom: 0.1em;
  margin-bottom: 0.1em;
  user-select: none;
  cursor: pointer;
  position: relative;
  margin-right: 0.1125em;
  transition: color .31s ease-in-out;
}

header h2::before {
  position: absolute;
  bottom: -0.075em;
  left: 0.015em;
  content: '';
  background: var(--gray);
  height: 1px;
  width: calc(100% - 0.015em);
  transform: scalex(0);
  transform-origin: 0;
  transition: transform .3s ease-in-out, background .2s ease-in-out;
}

header nav h2:not(:empty):not(:last-child)::after {
  content: ', '
}

header nav h2:not(:last-child)::before {
  width: calc(100% - 0.15em);
}

header h2.chosen::before {
    transform: scalex(1);
    background: var(--light);
}

header h2:not(.chosen):hover::before {
    transform: scalex(1);
    background: var(--gray);
}

header h2:not(.chosen):hover {
    color: var(--gray);
}
</style>
